const ListItem = ({ item }) => <li>{item.title}</li>;

export default ListItem;
